import { ConfirmDeleteModal } from '~/utils/modals';
import { NodeService as NodeServiceModel } from '~/scripts/services/model/node-service';
import APIV5 from '~/models/api';
import { UserModel } from '~/scripts/services/model/user';
import Node from '~/scripts/services/model/node';
import Repre from '~/scripts/services/model/repre';

export default class OoAdminObjectsListController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('angular').ILocationService} $location
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalService} $uibModal
	 * @param {NodeServiceModel} NodeService
	 * @param {UserModel} User
	 */
	constructor(
		$injector,
		$location,
		$scope,
		$timeout,
		$translate,
		$uibModal,
		NodeService,
		User,
	) {
		this.$injector = $injector;
		this.$location = $location;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.$uibModal = $uibModal;
		this.NodeService = NodeService;
		this.User = User;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.classKid = null;

		/** @type {number} */
		this.currentPage = 0;

		/** @type {number} */
		this.packetSize = 0;

		/** @type {number} */
		this.totalItems = 0;
	}

	/**
	 * @param {Node} node
	 */
	async delete(node) {
		const modal = new ConfirmDeleteModal(this.$injector);
		const answer = await modal.open(node.getName() || this.$translate.instant('designer.node-no-name'));

		if (answer) {
			await this.NodeService.delete(node.kid);
			await this.fetchObject(this.getCurrentIndex());
		}
	}

	/**
	 * @param {number} index
	 * @returns {Promise<any>}
	 */
	async fetchObject(index) {
		if (!this.classKid) {
			throw new Error('no kid');
		}

		/** @param {import('@knitiv/api-client-javascript').ObjectListOutput} result Data returned from objectList API */
		const result = await APIV5.instance.objectList({
			classKid:     this.classKid,
			options: {
				packet_size:  this.packetSize,
				packet_index: index,
			},
		}, { id: 'oo-admin-objects-list.fetch-object' });
		/** @type {Node[]} */
		const nodes = [];

		for (const [kid, n] of Object.entries(result.list)) {
			// @ts-ignore
			const node = new Node(this.$injector, kid, n.isa);
			if (n.repre_all) {
				for (const [repreKid, r] of Object.entries(n.repre_all)) {
					if (r) {
						node.addRepre(new Repre({
							lang: {
								kid: repreKid,
								isa: r.lang_isa,
							},
							value: r.name,
						}));
					}
				}
				nodes.push(node);
			}
		}
		this.$timeout(() => {
			this.nodes = nodes;
		});

		if (this.totalItems === -1) {
			this.totalItems = result.nb || 0;
			/** @deprecated */
			this.$scope.$emit('admin-oo-object-list-length', this.totalItems);
		}
	}

	getCurrentIndex() {
		return (this.currentPage - 1) * this.packetSize;
	}

	$onInit() {
		this.totalItems = -1;
		this.currentPage = 1;
		this.packetSize = 10;
		(async () => this.fetchObject(this.getCurrentIndex()))();
	}
}
